import React, {
  FC,
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  ReactNode,
  useEffect,
} from 'react'
import { useAuthState } from './AuthState'
import { listenAllLog, listenAllLikes } from '@/firebase/logs/actions'
import { EatLogType } from '@/types/logs'

const LogContext = createContext<{
  myEatLog: EatLogType[]
  myLikes: { id: number; updatedAt: Date }[]
  setMyEatLog: Dispatch<SetStateAction<EatLogType[]>>
  setMyLikes: Dispatch<SetStateAction<any[]>>
}>(null)

export const useLogState = () => useContext(LogContext)

const LogState: FC<{ children: ReactNode }> = ({ children }) => {
  const [myEatLog, setMyEatLog] = useState([])
  const [myLikes, setMyLikes] = useState([])
  const { currentUser } = useAuthState()
  useEffect(() => {
    if (currentUser) {
      const unSub = listenAllLog(currentUser.uid, setMyEatLog)
      return () => unSub()
    }
  }, [currentUser])
  useEffect(() => {
    if (currentUser) {
      const unSub = listenAllLikes(currentUser.uid, setMyLikes)
      return () => unSub()
    }
  }, [currentUser])
  return (
    <LogContext.Provider value={{ myEatLog, setMyEatLog, myLikes, setMyLikes }}>
      {children}
    </LogContext.Provider>
  )
}

export default LogState
